// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__s_OQu","content":"ManualTimeModal_content__1OmAK"};